<template>
	<b-row>
		<b-col>
			<b-card>
				<div slot="header">
					<span>{{ $t('warehouse.item.send') }}</span>
					<div class="card-header-actions">
						<b-link
							@click="newExpenses(null, 'create')"
							class="card-header-action btn-setting"
							style="font-size: 15px">
							<i class="fa fa-plus-circle"></i>
						</b-link>


					</div>
				</div>
				<div class="table-responsive table-wrapper">
					<b-table :items="items" class="generalTableClass"
							 :hover="hover" :striped="striped" :bordered="bordered"
							 :small="small"
							 :fixed="fixed"
							 :fields="fieldsForSended"
							 responsive="sm">
						<template slot="id" slot-scope="data">
							<strong>  {{ paginate(data.index, search.page, search.limit) }}</strong>
						</template>
						<template slot="documentStatus" slot-scope="data">
							<div>
								<span v-if="data.item.documentStatus == 'SENT'"
								class="bg-success">
								{{data.item.documentStatus}}</span>
								<span v-if="data.item.documentStatus == 'SUSPENDED'"
								class="bg-warning">
								{{data.item.documentStatus}}</span>
							</div>
						</template>
						<template slot="actions" slot-scope="data">


							<!--<b-link :key="data.item.id + 'delete'"-->
							<!--@click="onOpen(data.item.id)"-->
							<!--:id="'popOverDelete'+data.item.id"-->
							<!--&gt;-->
							<!--<i class="fa fa-trash"></i>-->
							<!--</b-link>-->
							<b-link v-if="data.item.documentStatus == 'SUSPENDED'" @click="editRequest(data.item.id)">
								<i class="fa fa-edit"></i>
							</b-link>
							<b-link :to="'/request-warehouse/production-request/view/' + data.item.id">
								<i class="fa fa-eye"></i>
							</b-link>

							<!-- <b-popover
								:key="data.item.id + 'popover'"
								:target="'popOverDelete'+data.item.id"
								placement="auto"
								container="myContainer"
								:ref="'popover'+data.item.id"
								class="refDeleteConfirm"
							>
								<template slot="title">
									<b-button @click="onClose(data.item.id)" class="close"
											  aria-label="Close"
											  style="margin-left: 5px">
										<span class="d-inline-block" aria-hidden="true">&times;</span>
									</b-button>
									{{$t('want_to_delete?')}}
								</template> -->
								<!-- <div>

									<div class="row mt-1">
										<div class="col-6">
											<b-button variant="outline-danger" size="sm" block
													  @click="onClose(data.item.id)">Yo'q
											</b-button>
										</div>
										<div class="col-6">
											<b-button variant="outline-success" size="sm" block
													  @click="onOk(data.item.id)">Ha
											</b-button>
										</div>
									</div>
								</div>
							</b-popover> -->

							<!-- <b-link v-if="selected=='pending'" v-b-tooltip.hover
									:title="$t('employees.update')" @click="showCreateRequestModal(data)"
							>
								<i class="fa fa-edit" style="position: absolute"></i>
							</b-link> -->

						</template>

					</b-table>
					 <nav>
						<b-pagination :total-rows="total" :per-page="search.limit"
								v-model="search.page"
								:prev-text="$t('pagination.prev')"
								:next-text="$t('pagination.next')"
								hide-goto-end-buttons/>
					</nav>
					<!-- <nav>
						<b-pagination :total-rows="total" :per-page="search.limit" v-model="search.page"
									  :prev-text="$t('pagination.prev')"
									  :next-text="$t('pagination.next')" hide-goto-end-buttons/>
					</nav> -->
					<vs-sidebar :click-not-close="true" position-right
					parent="body" default-index="1" color="primary"
								class="create-modal-tr" spacer
								v-model="sidebarOpen">
						<b-container index="1" v-if="sidebarOpen">
							<create-request-item
								@close="closeSidebar()"

							></create-request-item>
						</b-container>
					</vs-sidebar>
				</div>
			</b-card>
		</b-col>
	</b-row>
</template>

<script>
	import WhDocument from "../../services/wh-document.service";
	import {TokenService} from "../../services/storage.service";
	import CreateRequestItem from "./blocks/createRequestItem";

	export default {
		name: "RequestItems",
		components: {CreateRequestItem},
		props: {
			caption: {
				type: String,
				default: 'RequestTransfer'
			},
			hover: {
				type: Boolean,
				default: true
			},
			striped: {
				type: Boolean,
				default: true
			},
			bordered: {
				type: Boolean,
				default: false
			},
			small: {
				type: Boolean,
				default: false
			},
			fixed: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				search: {
					page: 1,
					limit: 20
				},
				items: [],
				total: 0,
				selected: 'sended',
				sidebarOpen: false,
			}
		},
		methods: {
			paginate(index, page_size, page_number) {
				--page_size;
				return (page_number * page_size) + index + 1;
			},
			async editRequest(id) {
				await this.newExpenses('edit', id)
			},
			async getRequestItem(id) {
				try {
					let res = await WhDocument.getOrderDocumentItemsList(id)
					if(res.data)
					await this.$store.commit('warehouse/setRequestItems', {edit: true, data: res.data})
					else
					await this.$store.commit('warehouse/setRequestItems',  {edit: false, data: null})
				}catch(e) {
					await this.$store.commit('warehouse/setRequestItems',{edit: false, data: null})
				}
			},
			async closeSidebar() {
				this.sidebarOpen = false;
				await this.fetchRequests()
			},
			async newExpenses(mode, id ) {
				if(mode == 'edit') {
					await this.getRequestItem(id)
					this.sidebarOpen = true;
				}else {
					await this.$store.commit('warehouse/setRequestItems', {edit: false, data: null})
					this.sidebarOpen = true;
				}
			},
			fetchRequests() {
				// let depId = parseInt(TokenService.getDepartmentId());
				// let depId = TokenService.getDepartmentId();
				let payload = {}
				// payload.depId = depId;
				payload.page = this.search.page;
				payload.limit = this.search.limit;
				WhDocument.fetchRequests(payload).then(response => {
					this.items = response.data.orderDocuments;
					this.total = response.data.total;
				})
			}
		},
		computed: {
			fieldsForSended() {
				return [
					{
						key: 'id',
						label: 'ID',
						'class': 'role_id',
					},
					{
						key: 'regDate',
						label: this.$t('pricing.costDate'),
					},
					{
						key: 'regNumber',
						label: this.$t('pricing.costNumber'),
					},
					{
						key: 'documentStatus',
						label: this.$t('sale.status'),
					},
					{
						key: 'fromDepartmentName',
						label: this.$t('incomes.fromDepartment')
					},
					{
						key: 'contragentName',
						label: this.$t('incomes.toDepartment')
					},
					{
						key: 'actions',
						'class': 'table_actions',
						label: this.$t('prices.item.actions'),
					},
				]
			},
		},
		created() {
			this.fetchRequests();
		},
		watch: {
			'search.page' : {
				async handler(newVal) {
					await this.fetchRequests()
				}
			},
		}
	}
</script>

<style scoped lang="scss">

</style>
